<template />

<script>
export default {
  mounted () {
    this.load();
  },

  methods: {
    load () {
      this.$http.get('/integration/click-to-call')
        .then(({ data }) => {
          const { config } = data;

          if (config && config.token) {
            Bus.$emit('integrationClickToCall', {
              name: data.name,
              config: {
                token: config.token,
                host: config.options.host,
                caller: config.options.caller,
                client_id: config.options.client_id,
              },
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>
